import * as DS from '@lessonnine/design-system.lib';

// Normally, the DS handles all the rebranding related work, but in our case we couldn't have this work because of SSR
// As we are loading the rebranded version of the DS only when the magazine shouldn't be rebranded, we can verify whether we are running rebranded or not by checking if a rebranded component (ShortText) is available
// If it's available, it means we are using the rebranded DS and should be rebranded
// If it isn't, it means we are using the non rebranded DS and should not be rebranded
const isRebranded = 'ShortText' in DS;

export { isRebranded };
